const header = document.getElementById('header');

function offset(el) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = window.scrollX || document.documentElement.scrollLeft,
        scrollTop = window.scrollY || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
let menuPosition = offset(document.querySelector('#js-NavMain'));

if(window.innerWidth > 960){
    window.addEventListener('scroll', function() {
        if(window.scrollY > 1){
            header.classList.add('header--fixed');
        }
        else{
            header.classList.remove('header--fixed');
        }
    })
}


// Rendre le fond du header fixe plus foncé quand le menu est ouvert
function addDarken() {

    const navMain = document.getElementById('js-NavMain');

    if (header.classList.contains('header--fixed') && navMain.classList.contains('js-open-submenu')) {
        header.classList.add('darken');
    } else {
        header.classList.remove('darken');
    }
}

document.addEventListener('DOMContentLoaded', addDarken);
document.addEventListener('scroll', addDarken);
document.addEventListener('click', addDarken);
